'use client';

import { fetchSeedingItemDetail, fetchSeedingItems } from '@/api/marketingPages';
import type {
  SeedingItemDetailResponse,
  SeedingItemsResponse,
} from '@/app/(activity)/campaigns/[slug]/types';
import useSWR from 'swr';

const SUMMARY_PAGE_SIZE = 100;
const SWR_OPTIONS = {
  dedupingInterval: 300_000,
  revalidateIfStale: false,
  revalidateOnFocus: false,
} as const;

type SummaryKey = readonly ['material-gallery-summary', number, boolean];
type DetailKey = readonly ['material-gallery-detail', number, number, boolean];

const fetchSummary = ([, marketingPageId, isPreview]: SummaryKey) =>
  fetchSeedingItems(marketingPageId, isPreview, 1, SUMMARY_PAGE_SIZE);

const fetchDetail = ([, marketingPageId, itemId, isPreview]: DetailKey) =>
  fetchSeedingItemDetail(itemId, marketingPageId, isPreview);

export function useMaterialGallerySummary(
  marketingPageId: number,
  isPreview: boolean,
  enabled: boolean,
) {
  return useSWR<SeedingItemsResponse, Error, SummaryKey>(
    enabled && marketingPageId > 0
      ? ['material-gallery-summary', marketingPageId, isPreview]
      : null,
    fetchSummary,
    SWR_OPTIONS,
  );
}

export function useMaterialGalleryDetail(
  marketingPageId: number,
  itemId: number | null,
  isPreview: boolean,
) {
  return useSWR<SeedingItemDetailResponse, Error, DetailKey>(
    marketingPageId > 0 && itemId && itemId > 0
      ? ['material-gallery-detail', marketingPageId, itemId, isPreview]
      : null,
    fetchDetail,
    SWR_OPTIONS,
  );
}
